import RecommendedResults from './RecommendedResults'
export default RecommendedResults
